import { WrapperProps } from '../components'
import { useMobileState } from '../hooks'
import { isMobileWidth } from '../utils'
import { createContextFactory } from './utils'

const [useIsMobile, IsMobileContextProvider] = createContextFactory<boolean>(
  'useIsMobile',
  'IsMobileContextProvider',
  isMobileWidth()
)

const IsMobileProvider = ({ children }: WrapperProps) => {
  return (
    <IsMobileContextProvider value={useMobileState()}>
      {children}
    </IsMobileContextProvider>
  )
}

export { IsMobileProvider, useIsMobile }
